import React, { Component } from 'react';

export default class PriceAnalysis extends React.Component {
	
	constructor(props) {
		
		super(props);
		
		this.state = props.price;
	}
	
	componentDidMount() {
		
		window["PriceAnalysisSetOptEqPrice"] = (equipmentRetail) => {
			
			let {
				carMultiplier, dateValid, equipmentTrade, finalRetail, dateRetail, dateTrade,
				finalRetailReference, finalTrade, kmRetail, kmTrade, otherAddRetail, otherAddTrade,
				otherMinusRetail, otherMinusTrade, remainingRetail, remainingTrade, tradeMultiplier
			} = this.state;
			
			equipmentTrade = equipmentRetail * carMultiplier;
			
			finalRetail = remainingRetail + dateRetail + kmRetail + equipmentRetail + otherAddRetail +
				otherMinusRetail;
			
			finalTrade = remainingTrade + dateTrade + kmTrade + equipmentTrade + otherAddTrade +
				otherMinusTrade;
			
			this.setState({ equipmentRetail, equipmentTrade, finalRetail, finalTrade });
		};
		
		window["PriceAnalysisSetOptEqPlusMinus"] = (otherAddRetail, otherMinusRetail) => {
			
			let {
				carMultiplier, dateValid, equipmentRetail, equipmentTrade, finalRetail,
				finalRetailReference, finalTrade, kmRetail, kmTrade, otherAddTrade, dateRetail,
				otherMinusTrade, remainingRetail, remainingTrade, tradeMultiplier, dateTrade
			} = this.state;
			
			otherAddTrade = otherAddRetail * carMultiplier;
			otherMinusTrade = otherMinusRetail * carMultiplier;
			
			finalRetail = remainingRetail + dateRetail + kmRetail + equipmentRetail + otherAddRetail +
				otherMinusRetail;
			
			finalTrade = remainingTrade + dateTrade + kmTrade + equipmentTrade + otherAddTrade +
				otherMinusTrade;
			
			this.setState({
				otherAddRetail, otherAddTrade, otherMinusRetail, otherMinusTrade, finalRetail, finalTrade
			});
		};
	}
	
	render() {
		
		const p = this.state;
		
		return (
			<table className="car-report table-main table-collapse-simple expand"
				id="car-report-price-analysis"
			>
				<thead>
					<tr><td colSpan="3">{text.finalPriceAnalysis}</td></tr>
					<tr>
						<th></th>
						<th>{text.finalPriceRetail}</th>
						<th>{text.finalPriceTrade}</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>{text.finalPrice} ({p.dateValid})</td>
						<td>{(p.remainingRetail + p.dateRetail).formatMoney(0, ".", ",") + text.cur}</td>
						<td>{(p.remainingTrade + p.dateTrade).formatMoney(0, ".", ",") + text.cur}</td>
					</tr>
					<tr>
						<td>{text.finalPriceKm}{(p.kmValid > 0 ? (" (" + p.kmValid + "km)") : "")}</td>
						<td>{p.kmRetail.formatMoney(0, ".", ",") + text.cur}</td>
						<td>{p.kmTrade.formatMoney(0, ".", ",") + text.cur}</td>
					</tr>
					<tr>
						<td>{text.finalPriceEq}</td>
						<td>{p.equipmentRetail.formatMoney(0, ".", ",") + text.cur}</td>
						<td>{p.equipmentTrade.formatMoney(0, ".", ",") + text.cur}</td>
					</tr>
					<tr>
						<td>{text.finalPriceMinus}</td>
						<td>{p.otherMinusRetail.formatMoney(0, ".", ",") + text.cur}</td>
						<td>{p.otherMinusTrade.formatMoney(0, ".", ",") + text.cur}</td>
					</tr>
					<tr>
						<td>{text.finalPricePlus}</td>
						<td>{p.otherAddRetail.formatMoney(0, ".", ",") + text.cur}</td>
						<td>{p.otherAddTrade.formatMoney(0, ".", ",") + text.cur}</td>
					</tr>
				</tbody>
				<tfoot>
					<tr>
						<td>{text.finalPriceFinal}</td>
						<td>{p.finalRetail.formatMoney(0, ".", ",") + text.cur}</td>
						<td>{p.finalTrade.formatMoney(0, ".", ",") + text.cur}</td>
					</tr>
				</tfoot>
			</table>
		);
	}
}